// extracted by mini-css-extract-plugin
export default {"container":"h8FkBM","templateImage":"bqKxy7","imageCell":"Xynijp","textCell":"hfP3T9","titleAndDescription":"LjpzpT","title":"WR1xWN","description":"ZRl1z0","quickView":"qWaJPQ"};